module.exports = __webpack_public_path__ + "static/media/AdHocLightBulb.76a6d067.svg";